import { render, staticRenderFns } from "./SupplierTourList.vue?vue&type=template&id=25ae66d0&scoped=true&"
import script from "./SupplierTourList.vue?vue&type=script&lang=js&"
export * from "./SupplierTourList.vue?vue&type=script&lang=js&"
import style0 from "./SupplierTourList.vue?vue&type=style&index=0&id=25ae66d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ae66d0",
  null
  
)

export default component.exports